import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OrderColorEnum } from '../../../constants/colors'
import { IStationState, OrderStatesEnum } from '../../../constants/order'
import { IOrder } from '../../../types/order'
import { RootState } from '../../store'

interface OrderState {
    stationState: {
        [OrderStatesEnum.NEW]: IOrder[] | undefined
        [OrderStatesEnum.IN_PROCESS]: IOrder[] | undefined
        [OrderStatesEnum.COOKED]: IOrder[] | undefined
    }
    state: {
        [key in OrderStatesEnum]: IOrder[] | undefined
    }
    orderKeyColorMap: Record<string, OrderColorEnum>
}

const initialState: OrderState = {
    stationState: {
        [OrderStatesEnum.NEW]: undefined,
        [OrderStatesEnum.IN_PROCESS]: undefined,
        [OrderStatesEnum.COOKED]: undefined,
    },
    state: {
        [OrderStatesEnum.NEW]: undefined,
        [OrderStatesEnum.QUEUED_FOR_PROCESSING]: undefined,
        [OrderStatesEnum.IN_PROCESS]: undefined,
        [OrderStatesEnum.COOKED]: undefined,
        [OrderStatesEnum.ASSEMBLED]: undefined,
        [OrderStatesEnum.DELIVERING]: undefined,
        [OrderStatesEnum.FINISHED]: undefined,
        [OrderStatesEnum.ANNULLED]: undefined,
        [OrderStatesEnum.CANCELLED]: undefined,
        [OrderStatesEnum.REFUNDED]: undefined,
        [OrderStatesEnum.UNDELIVERED]: undefined,
    },
    orderKeyColorMap: {},
}

interface IStationStateOrdersPayload {
    stationState: IStationState
    orders: IOrder[] | undefined
}

interface IStateOrdersPayload {
    state: OrderStatesEnum
    orders: IOrder[] | undefined
}

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        setStationStateOrders: (
            state,
            { payload: { stationState, orders } }: PayloadAction<IStationStateOrdersPayload>
        ) => void (state.stationState[stationState] = orders),
        setStateOrders: (
            state,
            { payload: { state: orderState, orders } }: PayloadAction<IStateOrdersPayload>
        ) => void (state.state[orderState] = orders),
        clearOrders: (state) => ({
            ...initialState,
            orderKeyColorMap: state.orderKeyColorMap,
        }),
        setAllOrderColors: (state, { payload: orderKeyColorMap }) =>
            void (state.orderKeyColorMap = orderKeyColorMap),
    },
})

export const { setStationStateOrders, setStateOrders, clearOrders, setAllOrderColors } =
    orderSlice.actions

export const orderSelectors = {
    orderColor:
        (orderKey: string) =>
        ({ order }: RootState) =>
            order.orderKeyColorMap[orderKey],
}

export default orderSlice.reducer
